import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <FaqSection />
        <IndexSection />
        <AboutSection />
        <FeaturesSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <CommentsSection />
        <MediaSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}